// React
import axios from 'axios';

// Config
import { DISCOUNT_SERVICE_URL, ORCHESTRATION_CAPABILITIES_ACTION } from './configuration';
import { DISCOUNT_SERVICE_ENDPOINT } from './configuration/discount-service';
import { setSnackbar } from './generic-action';


export const getCouponsDetails =
  ({ status = null, page = 0, size = 10 } = {}) =>
  async (dispatch) => {
    try {
      const params = { page, size };
      if (status) {
        params.status = status;
      }
      const response = await axios.get(`${DISCOUNT_SERVICE_URL}${DISCOUNT_SERVICE_ENDPOINT.COUPONS}`, {
        params
      });
      return response.data;
    } catch (error) {
      dispatch(
        setSnackbar({
          showSnackbar: true,
          message:
            error?.response?.data?.message ||
            error?.message,
          severity: 'error'
        })
      );
      return null;
    }
  };

export const getCouponDetailsById = (couponId) => async (dispatch) => {
  try {
    const response = await axios.get(`${DISCOUNT_SERVICE_URL}${DISCOUNT_SERVICE_ENDPOINT.COUPON}/${couponId}`);
    return response.data;
  } catch (error) {
    dispatch(
      setSnackbar({
        showSnackbar: true,
        message:
          error?.response?.data?.message ||
          error?.message ,
        severity: 'error'
      })
    );
    return null;
  }
};

export const getDiscountMasterData = () => async (dispatch) => {
  try {
    const response = await axios.get(`${DISCOUNT_SERVICE_URL}${DISCOUNT_SERVICE_ENDPOINT.MASTER_DATA}`, {
      headers: { 'Accept-Language': 'en' }
    });
    return response.data?.masterData || null;
  } catch (error) {
    dispatch(
      setSnackbar({
        showSnackbar: true,
        message:
          error?.response?.data?.message ||
          error?.message ,
        severity: 'error'
      })
    );
    return null;
  }
};

export const createCoupon = (payload) => async (dispatch) => {
  try {
    const response = await axios.post(`${ORCHESTRATION_CAPABILITIES_ACTION.ORCHESTRATION_SERVICE_URL}${DISCOUNT_SERVICE_ENDPOINT.COUPON}`, payload, {
      headers: {
        'Content-Type': 'application/json',
        'Accept-Language': 'en'
      }
    });
    return response.data;
  } catch (error) {
    dispatch(
      setSnackbar({
        showSnackbar: true,
        message:
          error?.response?.data?.message ||
          error?.message,
        severity: 'error'
      })
    );
    return null;
  }
};

export const updateCouponStatus = (couponId, isActive) => async (dispatch) => {
  try {
    const response = await axios.put(
      `${DISCOUNT_SERVICE_URL}${DISCOUNT_SERVICE_ENDPOINT.COUPON}/${couponId}`,
      { status: isActive ? 'ACTIVE' : 'INACTIVE' },
      { headers: { 'Content-Type': 'application/json' } }
    );
    return response.data;
  } catch (error) {
    dispatch(
      setSnackbar({
        showSnackbar: true,
        message:
          error?.response?.data?.message ||
          error?.message,
        severity: 'error'
      })
    );
    return null;
  }
};

export const deleteCoupon = (couponId) => async (dispatch) => {
  try {
    const response = await axios.delete(`${DISCOUNT_SERVICE_URL}${DISCOUNT_SERVICE_ENDPOINT.COUPON}/${couponId}`);
    return response.data ?? true;
  } catch (error) {
    dispatch(
      setSnackbar({
        showSnackbar: true,
        message:
          error?.response?.data?.message ||
          error?.message ,
        severity: 'error'
      })
    );
    return null;
  }
};
